// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13FD2","left":"styles_left__3VMQY","desktopActions":"styles_desktopActions__3-it1","title":"styles_title__3yA_-"};